import { csv } from "d3";
import { isArray, isString } from "lodash";

class Parser {

	constructor () {
		this.songs = {};
		this.artists = {};
	}
  
	async parse (filename) {
		await csv("/data/" + filename, (data) => {
			this.setArtist(data);
			this.setSong(data);
		});
	}

	setArtist (data) {
		let id = data["Id_Autorite"];

		if (this.artists[id] === undefined) { 
			this.artists[id] = {
				id: id,
				country_activity: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				country_birth: this.getFirstValue(data["Lieux_Naissances_Autorite"]).trim(),
				role: this.getFirstValue(data["Relation_Chanson_Autorite"]).trim(),
				birth_year: this.getFirstValue(data["Date_Naissance_Autorite"]).trim(),
				data_type: "autority",
				name: data["Forme_Retenue_Autorite"].split(",").splice(0,2).reverse().join(" ").trim(),
				label: data["Forme_Retenue_Autorite"].split(",").splice(0,2).reverse().join(" ").trim(),
			};
		}
	}

	setSong (data) {
		let id = data["Id_Chanson"];
        
		if (this.songs[id] === undefined) { 
			this.songs[id] = {
				id: data["Id_Chanson"],
				data_type: "song",
				language: this.getFirstValue(data["Langues_Chanson"]).trim(),
				note: data["Note_Chanson"].trim(),  
				title: data["Titre_Chanson"].trim(),
				label: data["Titre_Chanson"].trim(),
				parent_id: data["Id_Chanson_Parent"].trim(),
				has_parent: data["Id_Chanson_Parent"] != "",
				country_activity: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				country_birth: this.getFirstValue(data["Lieux_Naissances_Autorite"]).trim(),
				country_origin: this.getFirstValue(data["Lieux_Activites_Autorite"]).trim(),
				countries_origin: {
					[this.getFirstValue(data["Lieux_Activites_Autorite"])] : 1
				},
				year: data["Annee_Creation_Chanson"].trim(),
				artist_id: data["Id_Autorite"].trim(),
				artist_ids: [data["Id_Autorite"].trim()],
				author_id: data["Relation_Chanson_Autorite"].includes("Auteur") ? data["Id_Autorite"].trim() : "",
				author_ids: data["Relation_Chanson_Autorite"].includes("Auteur") ? [data["Id_Autorite"].trim()] : [],
				interpret_id: data["Relation_Chanson_Autorite"].includes("Interprète") ? data["Id_Autorite"].trim() : "",
				interpret_ids: data["Relation_Chanson_Autorite"].includes("Interprète") ? [data["Id_Autorite"].trim()] : [],
				composer_id: data["Relation_Chanson_Autorite"].includes("Compositeur") ? data["Id_Autorite"].trim() : "",
				composer_ids: data["Relation_Chanson_Autorite"].includes("Compositeur") ? [data["Id_Autorite"].trim()] : []
			};
		} else {
			this.songs[id].artist_ids.push(data["Id_Autorite"].trim());
			this.songs[id].artist_id = this.mode(this.songs[id].artist_ids);

			if (data["Relation_Chanson_Autorite"].includes("Auteur")) {
				this.songs[id].author_ids.push(data["Id_Autorite"].trim());
				this.songs[id].author_id = this.mode(this.songs[id].author_ids);
			}

			if (data["Relation_Chanson_Autorite"].includes("Interprète")) {
				this.songs[id].interpret_ids.push(data["Id_Autorite"].trim());
				this.songs[id].interpret_id = this.mode(this.songs[id].interpret_ids);
			}

			if (data["Relation_Chanson_Autorite"].includes("Compositeur")) {
				this.songs[id].composer_ids.push(data["Id_Autorite"].trim());
				this.songs[id].composer_id = this.mode(this.songs[id].composer_ids);
			}
            
			if (this.getFirstValue(data["Lieux_Activites_Autorite"]) !==  "") {
				this.songs[id].countries_origin[this.getFirstValue(data["Lieux_Activites_Autorite"])] = ++this.songs[id].countries_origin[this.getFirstValue(data["Lieux_Activites_Autorite"])] || 1;
				this.songs[id].country_origin = Object.keys(this.songs[id].countries_origin).reduce((a, b) => this.songs[id].countries_origin[a] > this.songs[id].countries_origin[b] ? a : b);
			}
		}
	}

	getFirstValue(value) {
		return value.split(";")[0];
	}
  
	toCSV (data) {
		let ignoreKeys = ["countries_origin"];

		let keys = Object.keys(data[0]).filter(k => !ignoreKeys.includes(k));
		let csv = keys.join(",");
		data.forEach(d => {
			csv += "\r\n";
			keys.forEach((key, i) => {  
                          
				if (isArray(d[key])) {
					csv += `"${d[key].join(";")}"`;
				} else if (isString(d[key]) ) {
					let result = d[key].replace(/"/g, "\"\"");
					csv += `"${result}"`;
				} else {
					csv += `"${d[key]}"`;
				}

				if (i < keys.length - 1) {
					csv += ",";
				}
			});
		});
		return csv;
	}

	mode (arr) {
		var numMapping = {};
		var greatestFreq = 0;
		var mode;
		arr.filter(item => item != "").forEach(function findMode(item) {
			numMapping[item] = (numMapping[item] || 0) + 1;
    
			if (greatestFreq < numMapping[item]) {
				greatestFreq = numMapping[item];
				mode = item;
			}
		});
		return mode;
	}
}

let parser = new Parser();

export { parser };
